// extracted by mini-css-extract-plugin
module.exports = {"header":"article_header__dp_k8","title":"article_title__3Ot98","date":"article_date__3XL11"};